import { render, staticRenderFns } from "./DiseaseRisk.vue?vue&type=template&id=3bb023aa&scoped=true&"
import script from "./DiseaseRisk.vue?vue&type=script&lang=js&"
export * from "./DiseaseRisk.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseRisk.vue?vue&type=style&index=0&id=3bb023aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb023aa",
  null
  
)

export default component.exports